export default "__VITE_ASSET__C1uJlO8u__"